import React, { useState, useContext, useEffect, useRef } from "react";
import GlobalContext from "../../framework/GlobalContext";
import classes from "./SalesConfigPanel.module.css";
import Checkbox from "../../framework/Checkbox";
import Switch from "../../framework/Switch";
import SelectInput from "../../framework/SelectInput";
import { useSelector } from "react-redux";
import NumberInput from "../../framework/NumberInput";
import {
  IS_SELL_IN_LOOSE_OPTIONS,
  PRESCRIPTION_OPTIONS,
  STOP_SALES_FOR_PRODUCTS_OPTIONS,
} from "./configurationConstants";
import PaymentModes from "../../common/paymentMode/PaymentModes";
import { executeScroll } from "../../utils/utils";
import ConfigurationContext from "./ConfigurationContext";

const SalesConfigPanel = (props) => {
  const {
    SEARCH_BY_SALTS,
    SHOW_MARGIN_ON_SALES,
    SHOW_MARGIN_IN_RUPEES,
    SHOW_MARGIN_IN_PERCENT,
    //BLUR_MARGIN_ON_SALES,
    ENABLE_DISCOUNT_ON_SALES,
    ENABLE_ROUND_OFF_ON_SALES,
    STOP_SALES_LESS_THAN_EFF_CP,
    SEARCH_BY_MRP,
    //FORCE_SELLING_PRICES_ON_SALES,
    EDIT_MRP_ON_SALES,
    FORCE_PATIENT_NAME,
    FORCE_PATIENT_PHONE_NUMBER,
    START_SALES_WITH_PATIENT,
    FORCE_DATA_COLLECTION_FOR_TB,
    FORCE_DOCTOR_NAME,
    // FORCE_DOCTOR_PRESCRIPTION,
    PRINT_DUPLICATE_ON_SALES,
    FORCE_PRINT_ON_H1,
    ENABLE_PRINT_NAME,
    SHOW_ZERO_STOCK_ON_SALES,
    ENABLE_SCAN_ON_SALES_FOR_ZERO_STOCK,
    SHOW_MEDICINE_MASTER_ON_SALES,
    ALLOW_SALES_OF_NEGATIVE_STOCK,
    STOP_EXPIRY_PRODUCTS_SEARCH,
    // SHOW_MULTIPLE_BATCH_FOR_SAME_BARCODE,
    // SHOW_TENDER_CALCULATOR,
    ENABLE_CREDIT_IN_SALES_BILL,
    // ENABLE_B2B_SALES,
    // ENABLE_CASH_COUNTER,
    ENABLE_REORDER_IN_REPORT,
    SHOW_NON_DISCOUNTED_MARGIN_ON_SALES,
    STOP_SALES_ABOVE_MRP,
    //SALES_LOOK_BACK,
    MAX_SALES_QUANTITY,
    // ENABLE_GROSS_MARGIN,
    IS_SELL_IN_LOOSE,
    ALLOW_RETURN_IN_SALES,
    DEFAULT_SALES_PAYMENT_MODE_ID,
    ALLOW_SALES_MULTI_PAYMENT,
    ALLOW_PROMISE_ORDER,
    ALLOW_MULTIPLE_SALES_TAB,
    ALLOW_EDIT_DISCOUNT,
    ALLOW_EDIT_ADDITIONAL_DISCOUNT,
    SALES_PRINT_COPIES,
    ALLOW_BACK_DATED_SALES,
    IS_PRESCRIPTION_MANDATORY,
    ALLOW_PATIENT_DISCOUNT_IN_SALES,
    STOP_SALES_FOR_PRODUCTS,
    SHOW_PAST_PRESCRIPTION,
    MAX_ALLOWABLE_DISCOUNT,
    SALES_PRODUCT_EDITABLE_AFTER_SELECT,
    FORCE_DOCTOR_LICENCE_FOR_H1_AND_TB,
    FORCE_DOCTOR_SPECIALITY_FOR_H1_AND_TB,
    FORCE_DOCTOR_ADDRESS_FOR_H1_AND_TB,
    FORCE_BILL_PRINT,
    ENABLE_ONLINE_ORDERS,
    ENABLE_HOME_DELIVERY,
    ENABLE_WHATSAPP_SEND,
  } = useSelector(
    (state) =>
      state.commonReducer.tabs[state.commonReducer.activeTabIndex].configData
  );
  const { formLabels } = useContext(ConfigurationContext);

  //   const { configData } = useSelector((state) => state.commonReducer);
  //   const [initialLoad, setInitialLoad] = useState(false);
  const { setCurrentComponent, displayModal } = useContext(GlobalContext);

  //const [salesLookback, setSalesLookback] = useState(SALES_LOOK_BACK);
  const [maxSalesQty, setMaxSalesQty] = useState(MAX_SALES_QUANTITY);
  const [copiesToPrint, setCopiesToPrint] = useState(SALES_PRINT_COPIES);

  // const [enableGrossMargin, setGrossMargin] = useState(
  //   ENABLE_GROSS_MARGIN
  // );
  const [defaultPaymentModeId, setDefaultPaymentModeId] = useState(
    DEFAULT_SALES_PAYMENT_MODE_ID
  );

  const [isSellInLoose, setIsSellInLoose] = useState(() => {
    return IS_SELL_IN_LOOSE_OPTIONS.find((op) => op.id === IS_SELL_IN_LOOSE);
  });
  const [stopSalesForProduct, setStopSalesForProduct] = useState(() => {
    return STOP_SALES_FOR_PRODUCTS_OPTIONS.find(
      (opn) => opn.id === STOP_SALES_FOR_PRODUCTS
    );
  });
  const [prescription, setPrescription] = useState(() => {
    return PRESCRIPTION_OPTIONS.find(
      (opn) => opn.id === IS_PRESCRIPTION_MANDATORY
    );
  });

  // const [allowPromiseOrder, setAllowPromiseOrder] =
  //   useState(ALLOW_PROMISE_ORDER);
  const [maxAllowableDiscount, setMaxAllowableDiscount] = useState(
    MAX_ALLOWABLE_DISCOUNT
  );

  const showMarginRef = useRef();
  const stopLessThanEffCpRef = useRef();
  const forcePatientNameRef = useRef();
  const forceDataCollectionForTbRef = useRef();
  const printDuplicateOnSalesRef = useRef();
  const isPrescriptionMandatoryRef = useRef();
  const isSellInLooseRef = useRef();
  const searchByMrpRef = useRef();
  const enableCreditInSalesRef = useRef();
  const allowBackdatedSalesRef = useRef();
  const showPastPrescriptionRef = useRef();
  const showNonDiscountedMarginOnSalesRef = useRef();
  const showMarginInPercentRef = useRef();
  const showMarginInRupeesRef = useRef();
  const enableDiscountOnSalesRef = useRef();
  const allowEditDiscountRef = useRef();
  const allowEditAdditionalDiscountRef = useRef();
  const maxAllowwableDiscountRef = useRef();
  const editMrpOnSalesRef = useRef();
  const stopSalesAboveMrpRef = useRef();
  const forcePatientPhoneNumberRef = useRef();
  const forceDoctorNameRef = useRef();
  const allowPatientDiscountInSalesRef = useRef();
  const forcePrintOnH1Ref = useRef();
  const forceDoctorLicenseForH1AndTbRef = useRef();
  const forceDoctorSpecialityForH1AndTbRef = useRef();
  const forceDoctorAddressForH1AndTb = useRef();
  const enablePrintNameRef = useRef();
  const forceBillPrintRef = useRef();
  const copiesToPrintRef = useRef();
  const showZeroStockOnSalesRef = useRef();
  const enableScanOnSalesForZeroStockRef = useRef();
  const showMedicineMasterOnSalesRef = useRef();
  const allowSalesOfNegativeStockRef = useRef();
  const stopExpiryProductSearchRef = useRef();
  const stopSalesForProductRef = useRef();
  const searchBySaltsRef = useRef();
  const salesProductEditableAfterSelectRef = useRef();
  const enableSalesMultiPaymentRef = useRef();
  const allowReturnInSalesRef = useRef();
  const allowPromiseOrderRef = useRef();
  const enableRoundOffOnSalesRef = useRef();
  const startSalesWithPatientRef = useRef();
  const enableReOrderInReportRef = useRef();
  const allowMultipleSalesTabRef = useRef();
  const enableOnlineOrdersRef = useRef();
  const maxSalesQuantityRef = useRef();
  const enableHomeDeliveryRef = useRef();
  const enableWhatsappSendRef = useRef();

  useEffect(() => {
    setCurrentComponent("config_sales_show_margin");
    showMarginRef.current.focus();
  }, [setCurrentComponent]);
  return (
    <div className={classes["salesconfigpanel-main-container"]}>
      <div className={classes["salesconfig-text-style"]}>Sales Settings</div>
      <div className={classes["salesconfig-sub-container"]}>
        <div className={classes["salesconfig-left-container"]}>
          <div className={classes["salesconfig-margin-section"]}>
            <div className={classes["salesconfig-margin-text"]}>Margin</div>

            <Checkbox
              id="config_sales_show_margin"
              name="showMargin"
              ref={showMarginRef}
              // value={showMarginOnSales}
              label={formLabels?.SHOW_MARGIN_ON_SALES?.displayName}
              checked={SHOW_MARGIN_ON_SALES}
              onFocus={() => {
                executeScroll(showMarginRef);
                setCurrentComponent("config_sales_show_margin");
              }}
              onChange={(e) => {
                // setMarginOnSales(e.target.checked);
                props.handleFormChange(
                  "SHOW_MARGIN_ON_SALES",
                  e.target.checked,
                  "sales"
                );
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "config_sales_show_margin",
                  down: SHOW_MARGIN_ON_SALES
                    ? "config_sales_show_non_discounted_margin"
                    : "config_sales_discount_settings",
                  left: "config_sales_show_margin",
                  right: SHOW_MARGIN_ON_SALES
                    ? "config_sales_show_non_discounted_margin"
                    : "config_sales_discount_settings",
                }),
              }}
            />
            <div className={classes["salesconfig-margin-details"]}>
              {/* {SHOW_MARGIN_ON_SALES && (
                <Switch
                  id="sales_edit_patient_activate_discount"
                  name="activatediscount"
                  checked={BLUR_MARGIN_ON_SALES }
                  // ref={editPatientActivateDiscountProgramRef}
                  label={formLabels?.?.displayName}
                  //   onFocus={() =>
                  //     setCurrentComponent("sales_edit_patient_activate_discount")
                  //   }
                  onChange={(e) =>
                    props.handleFormChange(
                      "BLUR_MARGIN_ON_SALES",
                      e.target.checked,
                      "sales"
                    )
                  }
                  inputProps={{
                    "data-markers": JSON.stringify({
                      up: "",
                      down: "sales_edit_patient_activate_loyalty",
                      left: "",
                      right: "sales_edit_patient_discount_program",
                    }),
                  }}
                />
              )} */}
              {/* <br /> */}

              <Switch
                disabled={!SHOW_MARGIN_ON_SALES}
                id="config_sales_show_non_discounted_margin"
                name="showNonDiscountedMargin"
                ref={showNonDiscountedMarginOnSalesRef}
                checked={SHOW_NON_DISCOUNTED_MARGIN_ON_SALES}
                label={
                  formLabels?.SHOW_NON_DISCOUNTED_MARGIN_ON_SALES?.displayName
                }
                onFocus={() => {
                  executeScroll(showNonDiscountedMarginOnSalesRef);
                  setCurrentComponent(
                    "config_sales_show_non_discounted_margin"
                  );
                }}
                onChange={(e) =>
                  props.handleFormChange(
                    "SHOW_NON_DISCOUNTED_MARGIN_ON_SALES",
                    e.target.checked,
                    "sales"
                  )
                }
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "config_sales_show_margin",
                    down: "config_sales_show_margin_in_per",
                    left: "config_sales_show_margin",
                    right: "config_sales_show_margin_in_per",
                  }),
                }}
              />
              <br />
              <Switch
                disabled={!SHOW_MARGIN_ON_SALES}
                id="config_sales_show_margin_in_per"
                name="showMarginInPer"
                label={formLabels?.SHOW_MARGIN_IN_PERCENT?.displayName}
                checked={SHOW_MARGIN_IN_PERCENT}
                ref={showMarginInPercentRef}
                onChange={(e) => {
                  // setShowMarginInPer(e.target.checked);
                  props.handleFormChange(
                    "SHOW_MARGIN_IN_PERCENT",
                    e.target.checked,
                    "sales"
                  );
                }}
                onFocus={() => {
                  executeScroll(showMarginInPercentRef);
                  setCurrentComponent("config_sales_show_margin_in_per");
                }}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "config_sales_show_non_discounted_margin",
                    down: "config_sales_show_margin_in_rupees",
                    left: "config_sales_show_non_discounted_margin",
                    right: "config_sales_show_margin_in_rupees",
                  }),
                }}
              />
              <br />
              <Switch
                disabled={!SHOW_MARGIN_ON_SALES}
                id="config_sales_show_margin_in_rupees"
                name="showMarginInRupees"
                label={formLabels?.SHOW_MARGIN_IN_RUPEES?.displayName}
                ref={showMarginInRupeesRef}
                checked={SHOW_MARGIN_IN_RUPEES}
                onFocus={() => {
                  executeScroll(showMarginInRupeesRef);
                  setCurrentComponent("config_sales_show_margin_in_rupees");
                }}
                onChange={(e) => {
                  // setShowMarginInRs(e.target.checked);
                  props.handleFormChange(
                    "SHOW_MARGIN_IN_RUPEES",
                    e.target.checked,
                    "sales"
                  );
                }}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "config_sales_show_margin_in_per",
                    down: "config_sales_discount_settings",
                    left: "config_sales_show_margin_in_per",
                    right: "config_sales_discount_settings",
                  }),
                }}
              />

              {/* <Checkbox
                id="sales_edit_patient_avoid_sms"
                name="disableOrderSMS"
                // ref={editPatientAvoidSmsRef}
                label={formLabels?.?.displayName}
                checked={enableGrossMargin}
                //  onFocus={() => setCurrentComponent("sales_edit_patient_avoid_sms")}
                onChange={(e) => {
                  setGrossMargin(e.target.checked);
                  props.handleFormChange(
                    "ENABLE_GROSS_MARGIN",
                    e.target.checked,
                    "sales"
                  );
                }}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "sales_edit_patient_address",
                    down: "",
                    left: "sales_edit_patient_credit_limit",
                    right: "sales_edit_patient_tb_details",
                  }),
                }}
              /> */}
            </div>
          </div>
          <div className={classes["salesconfig-discount-section"]}>
            <div className={classes["salesconfig-discount-settings-text"]}>
              Discount Settings
            </div>
            <Checkbox
              id="config_sales_discount_settings"
              name="discountSettings"
              ref={enableDiscountOnSalesRef}
              label={formLabels?.ENABLE_DISCOUNT_ON_SALES?.displayName}
              checked={ENABLE_DISCOUNT_ON_SALES}
              onFocus={() => {
                executeScroll(enableDiscountOnSalesRef);
                setCurrentComponent("config_sales_discount_settings");
              }}
              onChange={async (e) => {
                const x = e.target.checked;
                if (
                  await displayModal({
                    type: "warn",
                    title: x
                      ? "You are about to enable discount settings, by enabling this the user will be able to sell products at a discount. Do you wish to proceed?"
                      : "You are about to disable discount settings, by enabling this the user will be not able to sell products at a discount. Do you wish to proceed?",
                  })
                ) {
                  props.handleFormChange(
                    "ENABLE_DISCOUNT_ON_SALES",
                    x,
                    "sales"
                  );
                }
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: SHOW_MARGIN_ON_SALES
                    ? "config_sales_show_margin_in_rupees"
                    : "config_sales_show_margin",
                  down: ENABLE_DISCOUNT_ON_SALES
                    ? "config_sales_edit_discount"
                    : "config_sales_max_allowable_discount",
                  left: SHOW_MARGIN_ON_SALES
                    ? "config_sales_show_margin_in_rupees"
                    : "config_sales_show_margin",
                  right: ENABLE_DISCOUNT_ON_SALES
                    ? "config_sales_edit_discount"
                    : "config_sales_max_allowable_discount",
                }),
              }}
            />
            <Switch
              id="config_sales_edit_discount"
              name="editdiscount"
              label={formLabels?.ALLOW_EDIT_DISCOUNT?.displayName}
              ref={allowEditDiscountRef}
              onFocus={() => {
                executeScroll(allowEditDiscountRef);
                setCurrentComponent("config_sales_edit_discount");
              }}
              checked={ALLOW_EDIT_DISCOUNT}
              onChange={async (e) => {
                const x = e.target.checked;
                if (
                  await displayModal({
                    type: "warn",
                    title: x
                      ? "You are about to enable discount settings, by enabling this the user will be able to sell products at a discount. Do you wish to proceed?"
                      : "You are about to disable discount settings, by enabling this the user will be not able to sell products at a discount. Do you wish to proceed?",
                  })
                )
                  props.handleFormChange("ALLOW_EDIT_DISCOUNT", x, "sales");
              }}
              disabled={!ENABLE_DISCOUNT_ON_SALES}
            />
            <br />
            <Switch
              id="config_sales_edit_additional_discount"
              name="editadditionaldiscount"
              label={formLabels?.ALLOW_EDIT_ADDITIONAL_DISCOUNT?.displayName}
              ref={allowEditAdditionalDiscountRef}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "config_sales_edit_discount",
                  down: "config_sales_max_allowable_discount",
                  left: "config_sales_edit_discount",
                  right: "config_sales_max_allowable_discount",
                }),
              }}
              onFocus={() => {
                executeScroll(allowEditAdditionalDiscountRef);
                setCurrentComponent("config_sales_edit_additional_discount");
              }}
              checked={ALLOW_EDIT_ADDITIONAL_DISCOUNT}
              onChange={async (e) => {
                const x = e.target.checked;
                if (
                  await displayModal({
                    type: "warn",
                    title: x
                      ? "You are about to enable discount settings, by enabling this the user will be able to sell products at a discount. Do you wish to proceed?"
                      : "You are about to disable discount settings, by enabling this the user will be not able to sell products at a discount. Do you wish to proceed?",
                  })
                )
                  props.handleFormChange(
                    "ALLOW_EDIT_ADDITIONAL_DISCOUNT",
                    x,
                    "sales"
                  );
              }}
              disabled={!ENABLE_DISCOUNT_ON_SALES}
            />
            <div className={classes["salesconfig-textbox-wrapper"]}>
              <NumberInput
                id="config_sales_max_allowable_discount"
                name="maxAllowableDiscount"
                ref={maxAllowwableDiscountRef}
                label={formLabels?.MAX_ALLOWABLE_DISCOUNT?.displayName}
                onFocus={() => {
                  executeScroll(maxAllowwableDiscountRef);
                  setCurrentComponent("config_sales_max_allowable_discount");
                }}
                value={maxAllowableDiscount}
                // onFocus={() => setCurrentComponent("purchase_edit_distributor_name")}
                onValueChange={(values, e) => {
                  setMaxAllowableDiscount(values.floatValue);
                  props.handleFormChange(
                    "MAX_ALLOWABLE_DISCOUNT",
                    values.floatValue,
                    "SALES"
                  );
                }}
                isAllowed={(values) => {
                  const { formattedValue } = values;
                  return formattedValue <= 99;
                }}
                //onBlur={() => validateForm("distributorName", formState, errorState)}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: ENABLE_DISCOUNT_ON_SALES
                      ? "config_sales_edit_additional_discount"
                      : "config_sales_discount_settings",
                    down: "config_sales_stop_less_than_eff_cp",
                    left: ENABLE_DISCOUNT_ON_SALES
                      ? "config_sales_edit_additional_discount"
                      : "config_sales_discount_settings",
                    right: "config_sales_stop_less_than_eff_cp",
                  }),
                }}
                //   error={checkErrorStateExists(
                //     "purchase_edit_distributor_name",
                //     errorState
                //   )}
              />
            </div>
          </div>
          <div className={classes["salesconfig-rates-section"]}>
            <div className={classes["salesconfig-discount-settings-text"]}>
              Price/Rates Settings
            </div>
            <Checkbox
              id="config_sales_stop_less_than_eff_cp"
              name="stopLessThanEffCp"
              ref={stopLessThanEffCpRef}
              label={formLabels?.STOP_SALES_LESS_THAN_EFF_CP?.displayName}
              checked={STOP_SALES_LESS_THAN_EFF_CP}
              onFocus={() => {
                executeScroll(stopLessThanEffCpRef);
                setCurrentComponent("config_sales_stop_less_than_eff_cp");
              }}
              onChange={(e) => {
                // setStopSellingLessThanCp(e.target.checked);
                props.handleFormChange(
                  "STOP_SALES_LESS_THAN_EFF_CP",
                  e.target.checked,
                  "sales"
                );
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "config_sales_max_allowable_discount",
                  down: "config_sales_edit_mrp",
                  left: "config_sales_max_allowable_discount",
                  right: "config_sales_edit_mrp",
                }),
              }}
            />
            {/* <Checkbox
              id="sales_edit_patient_avoid_sms"
              name="disableOrderSMS"
              // ref={editPatientAvoidSmsRef}
              label={formLabels?.?.displayName}
              checked={forceSellingPriceOnSales}
              //  onFocus={() => setCurrentComponent("sales_edit_patient_avoid_sms")}
              onChange={(e) => {
                setForceSellingPriceOnSales(e.target.checked);
                props.handleFormChange(
                  "FORCE_SELLING_PRICES_ON_SALES",
                  e.target.checked,
                  "sales"
                );
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "sales_edit_patient_address",
                  down: "",
                  left: "sales_edit_patient_credit_limit",
                  right: "sales_edit_patient_tb_details",
                }),
              }}
            /> */}
            <Checkbox
              id="config_sales_edit_mrp"
              name="editMrpOnSales"
              ref={editMrpOnSalesRef}
              label={formLabels?.EDIT_MRP_ON_SALES?.displayName}
              checked={EDIT_MRP_ON_SALES}
              onFocus={() => {
                executeScroll(editMrpOnSalesRef);
                setCurrentComponent("config_sales_edit_mrp");
              }}
              onChange={(e) => {
                // setEditMrpOnSales(e.target.checked);
                props.handleFormChange(
                  "EDIT_MRP_ON_SALES",
                  e.target.checked,
                  "sales"
                );
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "config_sales_stop_less_than_eff_cp",
                  down: EDIT_MRP_ON_SALES
                    ? "config_sales_stop_sales_above_mrp"
                    : "config_sales_force_patient_name",
                  left: "config_sales_stop_less_than_eff_cp",
                  right: EDIT_MRP_ON_SALES
                    ? "config_sales_stop_sales_above_mrp"
                    : "config_sales_force_patient_name",
                }),
              }}
            />
            <Switch
              id="config_sales_stop_sales_above_mrp"
              name="stopSalesAboveMrp"
              ref={stopSalesAboveMrpRef}
              label={formLabels?.STOP_SALES_ABOVE_MRP?.displayName}
              onFocus={() => {
                executeScroll(stopSalesAboveMrpRef);
                setCurrentComponent("config_sales_stop_sales_above_mrp");
              }}
              checked={STOP_SALES_ABOVE_MRP}
              onChange={(e) =>
                props.handleFormChange(
                  "STOP_SALES_ABOVE_MRP",
                  e.target.checked,
                  "sales"
                )
              }
              disabled={!EDIT_MRP_ON_SALES}
            />
          </div>

          <div className={classes["salesconfig-rates-section"]}>
            <div className={classes["salesconfig-discount-settings-text"]}>
              Patient & Doctor Settings
            </div>
            <Checkbox
              id="config_sales_force_patient_name"
              name="forcePatientName"
              ref={forcePatientNameRef}
              label={formLabels?.FORCE_PATIENT_NAME?.displayName}
              checked={FORCE_PATIENT_NAME}
              onFocus={() => {
                executeScroll(forcePatientNameRef);
                setCurrentComponent("config_sales_force_patient_name");
              }}
              onChange={(e) => {
                // setForcePatientName(e.target.checked);
                props.handleFormChange(
                  "FORCE_PATIENT_NAME",
                  e.target.checked,
                  "sales"
                );
              }}
            />
            <Checkbox
              id="config_sales_force_patient_number"
              name="forcePatientPhoneNumber"
              ref={forcePatientPhoneNumberRef}
              label={formLabels?.FORCE_PATIENT_PHONE_NUMBER?.displayName}
              checked={FORCE_PATIENT_PHONE_NUMBER}
              onFocus={() => {
                executeScroll(forcePatientPhoneNumberRef);
                setCurrentComponent("config_sales_force_patient_number");
              }}
              onChange={(e) => {
                // setForcePatientPhoneNumber(e.target.checked);
                props.handleFormChange(
                  "FORCE_PATIENT_PHONE_NUMBER",
                  e.target.checked,
                  "sales"
                );
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "config_sales_force_patient_name",
                  down: "config_sales_force_doctor_name",
                  left: "config_sales_force_patient_name",
                  right: "config_sales_force_doctor_name",
                }),
              }}
            />

            <Checkbox
              id="config_sales_force_doctor_name"
              name="forceDoctorName"
              ref={forceDoctorNameRef}
              label={formLabels?.FORCE_DOCTOR_NAME?.displayName}
              checked={FORCE_DOCTOR_NAME}
              onFocus={() => {
                executeScroll(forceDoctorNameRef);
                setCurrentComponent("config_sales_force_doctor_name");
              }}
              onChange={(e) => {
                // setForceDoctorName(e.target.checked);
                props.handleFormChange(
                  "FORCE_DOCTOR_NAME",
                  e.target.checked,
                  "sales"
                );
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "config_sales_force_patient_number",
                  down: "config_sales_allow_patient_discount",
                  left: "config_sales_force_patient_number",
                  right: "config_sales_allow_patient_discount",
                }),
              }}
            />
            <Checkbox
              id="config_sales_allow_patient_discount"
              name="allowPatientDiscountInSales"
              label={formLabels?.ALLOW_PATIENT_DISCOUNT_IN_SALES?.displayName}
              ref={allowPatientDiscountInSalesRef}
              checked={ALLOW_PATIENT_DISCOUNT_IN_SALES}
              onChange={(e) => {
                props.handleFormChange(
                  "ALLOW_PATIENT_DISCOUNT_IN_SALES",
                  e.target.checked,
                  "sales"
                );
              }}
              onFocus={() => {
                executeScroll(allowPatientDiscountInSalesRef);
                setCurrentComponent("config_sales_allow_patient_discount");
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "config_sales_force_doctor_name",
                  down: "config_sales_force_data_collection_for_tb_patients",
                  left: "config_sales_force_doctor_name",
                  right: "config_sales_force_data_collection_for_tb_patients",
                }),
              }}
            />
            {/* <Checkbox
              id="sales_edit_patient_avoid_sms"
              name="disableOrderSMS"
              // ref={editPatientAvoidSmsRef}
              label={formLabels?.?.displayName}
              checked={forceDoctorPrescription}
              //  onFocus={() => setCurrentComponent("sales_edit_patient_avoid_sms")}
              onChange={(e) => {
                setForceDoctorPrescription(e.target.checked);
                props.handleFormChange(
                  "FORCE_DOCTOR_PRESCRIPTION",
                  e.target.checked,
                  "sales"
                );
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "sales_edit_patient_address",
                  down: "",
                  left: "sales_edit_patient_credit_limit",
                  right: "sales_edit_patient_tb_details",
                }),
              }}
            /> */}
          </div>
          <div className={classes["salesconfig-rates-section"]}>
            <div className={classes["salesconfig-discount-settings-text"]}>
              H1 and TB Sale Settings
            </div>
            <Checkbox
              id="config_sales_force_data_collection_for_tb_patients"
              name="forceDataCollectionForTb"
              ref={forceDataCollectionForTbRef}
              label={formLabels?.FORCE_DATA_COLLECTION_FOR_TB?.displayName}
              checked={FORCE_DATA_COLLECTION_FOR_TB}
              onFocus={() => {
                executeScroll(forceDataCollectionForTbRef);
                setCurrentComponent(
                  "config_sales_force_data_collection_for_tb_patients"
                );
              }}
              onChange={(e) => {
                // setDataCollectionForTb(e.target.checked);
                props.handleFormChange(
                  "FORCE_DATA_COLLECTION_FOR_TB",
                  e.target.checked,
                  "sales"
                );
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "config_sales_allow_patient_discount",
                  down: "config_sales_force_print_onh1",
                  left: "config_sales_allow_patient_discount",
                  right: "config_sales_force_print_onh1",
                }),
              }}
            />
            <Checkbox
              id="config_sales_force_print_onh1"
              name="forcePrintOnH1"
              ref={forcePrintOnH1Ref}
              label={formLabels?.FORCE_PRINT_ON_H1?.displayName}
              checked={FORCE_PRINT_ON_H1}
              onFocus={() => {
                executeScroll(forcePrintOnH1Ref);
                setCurrentComponent("config_sales_force_print_onh1");
              }}
              onChange={(e) => {
                // setForcePrintOnH1(e.target.checked);
                props.handleFormChange(
                  "FORCE_PRINT_ON_H1",
                  e.target.checked,
                  "sales"
                );
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "config_sales_force_data_collection_for_tb_patients",
                  down: "config_sales_mandate_for_h1_tb",
                  left: "config_sales_force_data_collection_for_tb_patients",
                  right: "config_sales_mandate_for_h1_tb",
                }),
              }}
            />
            <Checkbox
              id="config_sales_mandate_for_h1_tb"
              name="salesLicenseMandateForH1Tb"
              ref={forceDoctorLicenseForH1AndTbRef}
              label={
                formLabels?.FORCE_DOCTOR_LICENCE_FOR_H1_AND_TB?.displayName
              }
              checked={FORCE_DOCTOR_LICENCE_FOR_H1_AND_TB}
              onFocus={() => {
                executeScroll(forceDoctorLicenseForH1AndTbRef);
                setCurrentComponent("config_sales_mandate_for_h1_tb");
              }}
              onChange={(e) => {
                // setForcePatientName(e.target.checked);
                props.handleFormChange(
                  "FORCE_DOCTOR_LICENCE_FOR_H1_AND_TB",
                  e.target.checked,
                  "sales"
                );
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "config_sales_force_print_onh1",
                  down: "config_sales_doctor_speciality_for_h1_tb",
                  left: "config_sales_force_print_onh1",
                  right: "config_sales_doctor_speciality_for_h1_tb",
                }),
              }}
            />
            <Checkbox
              id="config_sales_doctor_speciality_for_h1_tb"
              name="salesDoctorSpeciality"
              ref={forceDoctorSpecialityForH1AndTbRef}
              label={
                formLabels?.FORCE_DOCTOR_SPECIALITY_FOR_H1_AND_TB?.displayName
              }
              checked={FORCE_DOCTOR_SPECIALITY_FOR_H1_AND_TB}
              onFocus={() => {
                executeScroll(forceDoctorSpecialityForH1AndTbRef);
                setCurrentComponent("config_sales_doctor_speciality_for_h1_tb");
              }}
              onChange={(e) => {
                // setForcePatientName(e.target.checked);
                props.handleFormChange(
                  "FORCE_DOCTOR_SPECIALITY_FOR_H1_AND_TB",
                  e.target.checked,
                  "sales"
                );
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "config_sales_mandate_for_h1_tb",
                  down: "config_sales_mandate_address_for_h1_tb",
                  left: "config_sales_mandate_for_h1_tb",
                  right: "config_sales_mandate_address_for_h1_tb",
                }),
              }}
            />
            <Checkbox
              id="config_sales_mandate_address_for_h1_tb"
              name="salesMandateDoctorAddress"
              ref={forceDoctorAddressForH1AndTb}
              label={
                formLabels?.FORCE_DOCTOR_ADDRESS_FOR_H1_AND_TB?.displayName
              }
              checked={FORCE_DOCTOR_ADDRESS_FOR_H1_AND_TB}
              onFocus={() => {
                executeScroll(forceDoctorAddressForH1AndTb);
                setCurrentComponent("config_sales_mandate_address_for_h1_tb");
              }}
              onChange={(e) => {
                // setForcePatientName(e.target.checked);
                props.handleFormChange(
                  "FORCE_DOCTOR_ADDRESS_FOR_H1_AND_TB",
                  e.target.checked,
                  "sales"
                );
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "config_sales_doctor_speciality_for_h1_tb",
                  down: "config_sales_print_duplicate",
                  left: "config_sales_doctor_speciality_for_h1_tb",
                  right: "config_sales_print_duplicate",
                }),
              }}
            />
          </div>
          <div className={classes["salesconfig-rates-section"]}>
            <div className={classes["salesconfig-discount-settings-text"]}>
              Print Settings
            </div>
            <Checkbox
              id="config_sales_print_duplicate"
              name="printDuplicateOnSales"
              ref={printDuplicateOnSalesRef}
              label={formLabels?.PRINT_DUPLICATE_ON_SALES?.displayName}
              checked={PRINT_DUPLICATE_ON_SALES}
              onFocus={() => {
                executeScroll(printDuplicateOnSalesRef);
                setCurrentComponent("config_sales_print_duplicate");
              }}
              onChange={(e) => {
                // setPrintDuplicateOnSales(e.target.checked);
                props.handleFormChange(
                  "PRINT_DUPLICATE_ON_SALES",
                  e.target.checked,
                  "sales"
                );
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "config_sales_mandate_address_for_h1_tb",
                  down: "config_sales_enable_print_name",
                  left: "config_sales_mandate_address_for_h1_tb",
                  right: "config_sales_enable_print_name",
                }),
              }}
            />

            <Checkbox
              id="config_sales_enable_print_name"
              name="enablePrintName"
              ref={enablePrintNameRef}
              label={formLabels?.ENABLE_PRINT_NAME?.displayName}
              checked={ENABLE_PRINT_NAME}
              onFocus={() => {
                executeScroll(enablePrintNameRef);
                setCurrentComponent("config_sales_enable_print_name");
              }}
              onChange={(e) => {
                // setEnablePrintName(e.target.checked);
                props.handleFormChange(
                  "ENABLE_PRINT_NAME",
                  e.target.checked,
                  "sales"
                );
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "config_sales_print_duplicate",
                  down: "config_sales_force_bill_print",
                  left: "config_sales_print_duplicate",
                  right: "config_sales_force_bill_print",
                }),
              }}
            />
            <Checkbox
              id="config_sales_force_bill_print"
              name="forceBillPrint"
              ref={forceBillPrintRef}
              label={formLabels?.FORCE_BILL_PRINT?.displayName}
              checked={FORCE_BILL_PRINT}
              onChange={(e) => {
                props.handleFormChange(
                  "FORCE_BILL_PRINT",
                  e.target.checked,
                  "sales"
                );
              }}
              onFocus={() => {
                executeScroll(forceBillPrintRef);
                setCurrentComponent("config_sales_force_bill_print");
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "config_sales_enable_print_name",
                  down: "config_sales_print_quantity",
                  left: "config_sales_enable_print_name",
                  right: "config_sales_print_quantity",
                }),
              }}
            />
            <div className={classes["salesconfig-textbox-wrapper"]}>
              <NumberInput
                id="config_sales_print_quantity"
                name="printCopies"
                ref={copiesToPrintRef}
                label={formLabels?.SALES_PRINT_COPIES?.displayName}
                value={copiesToPrint}
                onFocus={() => {
                  executeScroll(copiesToPrintRef);
                  setCurrentComponent("config_sales_print_quantity");
                }}
                onValueChange={(values, e) => {
                  setCopiesToPrint(values.floatValue);
                  props.handleFormChange(
                    "SALES_PRINT_COPIES",
                    values.floatValue,
                    "SALES"
                  );
                }}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "config_sales_force_bill_print",
                    down: "config_sales_prescription",
                    left: "config_sales_force_bill_print",
                    right: "config_sales_prescription",
                  }),
                }}
                isAllowed={(values) => {
                  const { formattedValue } = values;
                  return formattedValue >= 1;
                }}
              />
            </div>
          </div>
          <div className={classes["salesconfig-rates-section"]}>
            <div className={classes["salesconfig-discount-settings-text"]}>
              Prescription Settings
            </div>
            <div className={classes["salesconfig-loose-section"]}>
              <div className={classes["salesconfig-loose-text"]}>
                Mandate Prescription
              </div>
              <SelectInput
                id="config_sales_prescription"
                name="isPrescriptionMandatory"
                label={formLabels?.IS_PRESCRIPTION_MANDATORY?.displayName}
                ref={isPrescriptionMandatoryRef}
                onFocus={() => {
                  executeScroll(isPrescriptionMandatoryRef);
                  setCurrentComponent("config_sales_prescription");
                }}
                onChange={(event, value) => {
                  setPrescription(value);
                  props.handleFormChange(
                    "IS_PRESCRIPTION_MANDATORY",
                    value.id,
                    "SALES"
                  );
                }}
                getOptionLabel={(option) => option.label}
                isOptionEqualToValue={(option, value) =>
                  value.label === option.label
                }
                options={PRESCRIPTION_OPTIONS}
                value={prescription}
                markers={JSON.stringify({
                  up: "config_sales_print_quantity",
                  down: "config_sales_show_past_prescripition",
                  left: "config_sales_print_quantity",
                  right: "config_sales_show_past_prescripition",
                })}
              />
            </div>
            <Checkbox
              id="config_sales_show_past_prescripition"
              name="showPastPrescription"
              ref={showPastPrescriptionRef}
              label={formLabels?.SHOW_PAST_PRESCRIPTION?.displayName}
              checked={SHOW_PAST_PRESCRIPTION}
              onChange={(e) => {
                props.handleFormChange(
                  "SHOW_PAST_PRESCRIPTION",
                  e.target.checked,
                  "sales"
                );
              }}
              onFocus={() => {
                executeScroll(showPastPrescriptionRef);
                setCurrentComponent("config_sales_show_past_prescripition");
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "config_sales_prescription",
                  down: "config_sales_sell_in_loose",
                  left: "config_sales_prescription",
                  right: "config_sales_sell_in_loose",
                }),
              }}
            />
          </div>
        </div>
        <div className={classes["salesconfig-right-container"]}>
          <div className={classes["salesconfig-stocksetting-section"]}>
            <div className={classes["salesconfig-stocksetting-text"]}>
              Stock Settings
            </div>
            <div className={classes["salesconfig-loose-section"]}>
              <div className={classes["salesconfig-loose-text"]}>
                Do you sell an item in loose quantity?
              </div>
              <div className={classes["salesconfig-loose-select"]}>
                <SelectInput
                  id="config_sales_sell_in_loose"
                  label={formLabels?.IS_SELL_IN_LOOSE?.displayName}
                  name="isSellInLoose"
                  ref={isSellInLooseRef}
                  onFocus={() => {
                    executeScroll(isSellInLooseRef);
                    setCurrentComponent("config_sales_sell_in_loose");
                  }}
                  onChange={(event, value) => {
                    setIsSellInLoose(value);
                    props.handleFormChange(
                      "IS_SELL_IN_LOOSE",
                      value.id,
                      "SALES"
                    );
                  }}
                  getOptionLabel={(option) => option.label}
                  isOptionEqualToValue={(option, value) =>
                    value.label === option.label
                  }
                  options={IS_SELL_IN_LOOSE_OPTIONS}
                  value={isSellInLoose}
                  markers={JSON.stringify({
                    up: "config_sales_show_past_prescripition",
                    down: "config_sales_show_zero_stock",
                    left: "config_sales_show_past_prescripition",
                    right: "config_sales_show_zero_stock",
                  })}
                />
              </div>
            </div>
            <Checkbox
              id="config_sales_show_zero_stock"
              name="showZeroStockOnSales"
              ref={showZeroStockOnSalesRef}
              label={formLabels?.SHOW_ZERO_STOCK_ON_SALES?.displayName}
              checked={SHOW_ZERO_STOCK_ON_SALES}
              onFocus={() => {
                executeScroll(showZeroStockOnSalesRef);
                setCurrentComponent("config_sales_show_zero_stock");
              }}
              onChange={(e) => {
                // setZeroStockOnSales(e.target.checked);
                props.handleFormChange(
                  "SHOW_ZERO_STOCK_ON_SALES",
                  e.target.checked,
                  "sales"
                );
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "config_sales_sell_in_loose",
                  down: SHOW_ZERO_STOCK_ON_SALES
                    ? "config_sales_enable_scan_for_zero_stock"
                    : "config_sales_search_by_expiry",
                  left: "config_sales_sell_in_loose",
                  right: SHOW_ZERO_STOCK_ON_SALES
                    ? "config_sales_enable_scan_for_zero_stock"
                    : "config_sales_search_by_expiry",
                }),
              }}
            />

            <Switch
              id="config_sales_enable_scan_for_zero_stock"
              name="enableScanOnSalesForZeroStock"
              ref={enableScanOnSalesForZeroStockRef}
              label={
                formLabels?.ENABLE_SCAN_ON_SALES_FOR_ZERO_STOCK?.displayName
              }
              onFocus={() => {
                executeScroll(enableScanOnSalesForZeroStockRef);
                setCurrentComponent("config_sales_enable_scan_for_zero_stock");
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "config_sales_show_zero_stock",
                  down: "config_sales_medicine_master",
                  left: "config_sales_show_zero_stock",
                  right: "config_sales_medicine_master",
                }),
              }}
              checked={ENABLE_SCAN_ON_SALES_FOR_ZERO_STOCK}
              //   onFocus={() =>
              //     setCurrentComponent("sales_edit_patient_activate_discount")
              //   }
              disabled={!SHOW_ZERO_STOCK_ON_SALES}
              onChange={(e) => {
                // setScanOnSalesForZeroStock(e.target.checked);
                props.handleFormChange(
                  "ENABLE_SCAN_ON_SALES_FOR_ZERO_STOCK",
                  e.target.checked,
                  "sales"
                );
              }}
            />

            <br />

            <Switch
              id="config_sales_medicine_master"
              name="showMedicineMasterOnSales"
              ref={showMedicineMasterOnSalesRef}
              label={formLabels?.SHOW_MEDICINE_MASTER_ON_SALES?.displayName}
              disabled={!SHOW_ZERO_STOCK_ON_SALES}
              onFocus={() => {
                executeScroll(showMedicineMasterOnSalesRef);
                setCurrentComponent("config_sales_medicine_master");
              }}
              checked={SHOW_MEDICINE_MASTER_ON_SALES}
              //   onFocus={() =>
              //     setCurrentComponent("sales_edit_patient_activate_discount")
              //   }
              onChange={(e) => {
                // setMedicineMasterOnSales(e.target.checked);
                props.handleFormChange(
                  "SHOW_MEDICINE_MASTER_ON_SALES",
                  e.target.checked,
                  "sales"
                );
              }}
            />

            <br />

            <Switch
              disabled={!SHOW_ZERO_STOCK_ON_SALES}
              id="config_sales_allow_Sales_on_zero_stock"
              name="allowSalesOfNegativeStock"
              ref={allowSalesOfNegativeStockRef}
              label={formLabels?.ALLOW_SALES_OF_NEGATIVE_STOCK?.displayName}
              onFocus={() => {
                executeScroll(allowSalesOfNegativeStockRef);
                setCurrentComponent("config_sales_allow_Sales_on_zero_stock");
              }}
              checked={ALLOW_SALES_OF_NEGATIVE_STOCK}
              //   onFocus={() =>
              //     setCurrentComponent("sales_edit_patient_activate_discount")
              //   }
              onChange={(e) => {
                // setSalesOnNegativeStock(e.target.checked);
                props.handleFormChange(
                  "ALLOW_SALES_OF_NEGATIVE_STOCK",
                  e.target.checked,
                  "sales"
                );
              }}
            />
            <Checkbox
              id="config_sales_search_by_expiry"
              ref={stopExpiryProductSearchRef}
              name="stopExpiryProductSearch"
              label={formLabels?.STOP_EXPIRY_PRODUCTS_SEARCH?.displayName}
              checked={STOP_EXPIRY_PRODUCTS_SEARCH}
              onFocus={() => {
                executeScroll(stopExpiryProductSearchRef);
                setCurrentComponent("config_sales_search_by_expiry");
              }}
              onChange={(e) => {
                // setSearchBySalts(e.target.checked);
                props.handleFormChange(
                  "STOP_EXPIRY_PRODUCTS_SEARCH",
                  e.target.checked,
                  "SALES"
                );
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: SHOW_ZERO_STOCK_ON_SALES
                    ? "config_sales_allow_Sales_on_zero_stock"
                    : "config_sales_show_zero_stock",
                  down: "config_sales_expiry_validation",
                  left: SHOW_ZERO_STOCK_ON_SALES
                    ? "config_sales_allow_Sales_on_zero_stock"
                    : "config_sales_show_zero_stock",
                  right: "config_sales_expiry_validation",
                }),
              }}
            />
            <div className={classes["salesconfig-loose-section"]}>
              <div className={classes["salesconfig-loose-text"]}>
                Expiry validation to stop sales
              </div>
              <div className={classes["salesconfig-loose-select"]}>
                <SelectInput
                  id="config_sales_expiry_validation"
                  label={formLabels?.STOP_SALES_FOR_PRODUCTS?.displayName}
                  name="stopSalesForProduct"
                  ref={stopSalesForProductRef}
                  onChange={(event, value) => {
                    setStopSalesForProduct(value);
                    props.handleFormChange(
                      "STOP_SALES_FOR_PRODUCTS",
                      value.id,
                      "SALES"
                    );
                  }}
                  onFocus={() => {
                    executeScroll(stopSalesForProductRef);
                    setCurrentComponent("config_sales_expiry_validation");
                  }}
                  getOptionLabel={(option) => option.label}
                  isOptionEqualToValue={(option, value) =>
                    value.label === option.label
                  }
                  options={STOP_SALES_FOR_PRODUCTS_OPTIONS}
                  value={stopSalesForProduct}
                  markers={JSON.stringify({
                    up: "config_sales_search_by_expiry",
                    down: "config_sales_search_by_mrp",
                    left: "config_sales_search_by_expiry",
                    right: "config_sales_search_by_mrp",
                  })}
                />
              </div>
            </div>

            {/* <Checkbox
              id="sales_edit_patient_avoid_sms"
              name="disableOrderSMS"
              // ref={editPatientAvoidSmsRef}
              label={formLabels?.?.displayName}
              checked={showMultipleBatchForSameBarcode}
              //  onFocus={() => setCurrentComponent("sales_edit_patient_avoid_sms")}
              onChange={(e) => {
                setMultipleBatchForSameBarcode(e.target.checked);
                props.handleFormChange(
                  "SHOW_MULTIPLE_BATCH_FOR_SAME_BARCODE",
                  e.target.checked,
                  "sales"
                );
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "sales_edit_patient_address",
                  down: "",
                  left: "sales_edit_patient_credit_limit",
                  right: "sales_edit_patient_tb_details",
                }),
              }}
            /> */}

            {/* <Checkbox
              id="sales_edit_patient_avoid_sms"
              name="disableOrderSMS"
              // ref={editPatientAvoidSmsRef}
              label={formLabels?.?.displayName}
              checked={enableLiveStockSales}
              //  onFocus={() => setCurrentComponent("sales_edit_patient_avoid_sms")}
              onChange={(e) => {
                setLiveStockOnSales(e.target.checked);
                props.handleFormChange(
                  "ENABLE_LIVE_STOCK_ON_SALES",
                  e.target.checked,
                  "sales"
                );
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "sales_edit_patient_address",
                  down: "",
                  left: "sales_edit_patient_credit_limit",
                  right: "sales_edit_patient_tb_details",
                }),
              }}
            /> */}
          </div>
          <div className={classes["salesconfig-rates-section"]}>
            <div className={classes["salesconfig-discount-settings-text"]}>
              Product Search
            </div>
            <Checkbox
              id="config_sales_search_by_mrp"
              name="searchByMrp"
              ref={searchByMrpRef}
              label={formLabels?.SEARCH_BY_MRP?.displayName}
              checked={SEARCH_BY_MRP}
              onFocus={() => {
                executeScroll(searchByMrpRef);
                setCurrentComponent("config_sales_search_by_mrp");
              }}
              onChange={(e) => {
                // setSearchByMrp(e.target.checked);
                props.handleFormChange(
                  "SEARCH_BY_MRP",
                  e.target.checked,
                  "sales"
                );
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "config_sales_expiry_validation",
                  down: "config_sales_search_by_salts",
                  left: "config_sales_expiry_validation",
                  right: "config_sales_search_by_salts",
                }),
              }}
            />
            <Checkbox
              id="config_sales_search_by_salts"
              name="searchBySalts"
              ref={searchBySaltsRef}
              label={formLabels?.SEARCH_BY_SALTS?.displayName}
              checked={SEARCH_BY_SALTS}
              onFocus={() => {
                executeScroll(searchBySaltsRef);
                setCurrentComponent("config_sales_search_by_salts");
              }}
              onChange={(e) => {
                // setSearchBySalts(e.target.checked);
                props.handleFormChange(
                  "SEARCH_BY_SALTS",
                  e.target.checked,
                  "sales"
                );
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "config_sales_search_by_mrp",
                  down: "config_sales_product_editable_after_select",
                  left: "config_sales_search_by_mrp",
                  right: "config_sales_product_editable_after_select",
                }),
              }}
            />
            <Checkbox
              id="config_sales_product_editable_after_select"
              name="salesProductEditable"
              ref={salesProductEditableAfterSelectRef}
              label={
                formLabels?.SALES_PRODUCT_EDITABLE_AFTER_SELECT?.displayName
              }
              checked={SALES_PRODUCT_EDITABLE_AFTER_SELECT}
              onFocus={() => {
                executeScroll(salesProductEditableAfterSelectRef);
                setCurrentComponent(
                  "config_sales_product_editable_after_select"
                );
              }}
              onChange={(e) => {
                // setSearchBySalts(e.target.checked);
                props.handleFormChange(
                  "SALES_PRODUCT_EDITABLE_AFTER_SELECT",
                  e.target.checked,
                  "sales"
                );
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "config_sales_search_by_salts",
                  down: "config_sales_allow_credit_sales",
                  left: "config_sales_search_by_salts",
                  right: "config_sales_allow_credit_sales",
                }),
              }}
            />
          </div>

          <div className={classes["salesconfig-stocksetting-section"]}>
            <div className={classes["salesconfig-stocksetting-text"]}>
              Payment Settings
            </div>
            {/* <Checkbox
              id="sales_edit_patient_avoid_sms"
              name="disableOrderSMS"
              // ref={editPatientAvoidSmsRef}
              label={formLabels?.?.displayName}
              checked={showTenderCalculator}
              //  onFocus={() => setCurrentComponent("sales_edit_patient_avoid_sms")}
              onChange={(e) => {
                setTenderCalculator(e.target.checked);
                props.handleFormChange(
                  "SHOW_TENDER_CALCULATOR",
                  e.target.checked,
                  "sales"
                );
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "sales_edit_patient_address",
                  down: "",
                  left: "sales_edit_patient_credit_limit",
                  right: "sales_edit_patient_tb_details",
                }),
              }}
            /> */}

            <Checkbox
              id="config_sales_allow_credit_sales"
              name="enableCreditInSales"
              ref={enableCreditInSalesRef}
              label={formLabels?.ENABLE_CREDIT_IN_SALES_BILL?.displayName}
              checked={ENABLE_CREDIT_IN_SALES_BILL}
              onFocus={() => {
                executeScroll(enableCreditInSalesRef);
                setCurrentComponent("config_sales_allow_credit_sales");
              }}
              onChange={(e) => {
                // setCreditInSalesBill(e.target.checked);
                props.handleFormChange(
                  "ENABLE_CREDIT_IN_SALES_BILL",
                  e.target.checked,
                  "sales"
                );
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "config_sales_product_editable_after_select",
                  down: "config_sales_enable_multi_payment",
                  left: "config_sales_product_editable_after_select",
                  right: "config_sales_enable_multi_payment",
                }),
              }}
            />

            <Checkbox
              id="config_sales_enable_multi_payment"
              name="enableSalesMultiPayment"
              ref={enableSalesMultiPaymentRef}
              label={formLabels?.ALLOW_SALES_MULTI_PAYMENT?.displayName}
              checked={ALLOW_SALES_MULTI_PAYMENT}
              onFocus={() => {
                executeScroll(enableSalesMultiPaymentRef);
                setCurrentComponent("config_sales_enable_multi_payment");
              }}
              onChange={(e) => {
                // setAllowMultiPayment(e.target.checked);
                props.handleFormChange(
                  "ALLOW_SALES_MULTI_PAYMENT",
                  e.target.checked,
                  "sales"
                );
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "config_sales_allow_credit_sales",
                  down: "payment-modes-select",
                  left: "config_sales_allow_credit_sales",
                  right: "payment-modes-select",
                }),
              }}
            />

            <div className={classes["salesconfig-textbox-wrapper"]}>
              <PaymentModes
                label={formLabels?.DEFAULT_SALES_PAYMENT_MODE_ID?.displayName}
                showsIn="SALES"
                defaultPaymentModeId={defaultPaymentModeId}
                showPaymentModeOnly={true}
                getPaymentMode={(value) => {
                  setDefaultPaymentModeId(value.paymentModeId);
                  props.handleFormChange(
                    "DEFAULT_SALES_PAYMENT_MODE_ID",
                    value.paymentModeId,
                    "sales"
                  );
                }}
                onFocus={() =>
                  setCurrentComponent("config_sales_default_payment_mode_id")
                }
                markers={{
                  up: "config_sales_enable_multi_payment",
                  down: "config_sales_allow_back_dated_sales",
                  left: "config_sales_enable_multi_payment",
                  right: "config_sales_allow_back_dated_sales",
                }}
              />
            </div>
          </div>
          {/* <div className={classes["salesconfig-stocksetting-section"]}>
              <div className={classes["salesconfig-stocksetting-text"]}>
                Sales Register Settings
              </div>
              <Checkbox
                id="sales_edit_patient_avoid_sms"
                name="disableOrderSMS"
                // ref={editPatientAvoidSmsRef}
                label={formLabels?.?.displayName}
                checked={enableSalesRegister}
                //  onFocus={() => setCurrentComponent("sales_edit_patient_avoid_sms")}
                onChange={(e) => {
                  setSalesRegister(e.target.checked);
                  props.handleFormChange(
                    "ENABLE_SALES_REGISTER",
                    e.target.checked,
                    "sales"
                  );
                }}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "sales_edit_patient_address",
                    down: "",
                    left: "sales_edit_patient_credit_limit",
                    right: "sales_edit_patient_tb_details",
                  }),
                }}
              />
            </div> */}

          <div className={classes["salesconfig-stocksetting-section"]}>
            <div className={classes["salesconfig-stocksetting-text"]}>
              Miscellaneous
            </div>
            <Checkbox
              id="config_sales_allow_back_dated_sales"
              name="allowBackdatedSales"
              ref={allowBackdatedSalesRef}
              label={formLabels?.ALLOW_BACK_DATED_SALES?.displayName}
              checked={ALLOW_BACK_DATED_SALES}
              onFocus={() => {
                executeScroll(allowBackdatedSalesRef);
                setCurrentComponent("config_sales_allow_back_dated_sales");
              }}
              onChange={(e) => {
                // setReturnInSales(e.target.checked);
                props.handleFormChange(
                  "ALLOW_BACK_DATED_SALES",
                  e.target.checked,
                  "sales"
                );
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "payment-modes-select",
                  down: "config_sales_allow_return",
                  left: "payment-modes-select",
                  right: "config_sales_allow_return",
                }),
              }}
            />
            <Checkbox
              id="config_sales_allow_return"
              name="allowReturnInSales"
              ref={allowReturnInSalesRef}
              label={formLabels?.ALLOW_RETURN_IN_SALES?.displayName}
              checked={ALLOW_RETURN_IN_SALES}
              onFocus={() => {
                executeScroll(allowReturnInSalesRef);
                setCurrentComponent("config_sales_allow_return");
              }}
              onChange={(e) => {
                // setReturnInSales(e.target.checked);
                props.handleFormChange(
                  "ALLOW_RETURN_IN_SALES",
                  e.target.checked,
                  "sales"
                );
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "config_sales_allow_back_dated_sales",
                  down: "config_sales_allow_promise_order",
                  left: "config_sales_allow_back_dated_sales",
                  right: "config_sales_allow_promise_order",
                }),
              }}
            />
            <Checkbox
              id="config_sales_allow_promise_order"
              name="allowPromiseOrder"
              label={formLabels?.ALLOW_PROMISE_ORDER?.displayName}
              checked={ALLOW_PROMISE_ORDER}
              ref={allowPromiseOrderRef}
              onChange={(e) => {
                // setAllowPromiseOrder(e.target.checked);
                props.handleFormChange(
                  "ALLOW_PROMISE_ORDER",
                  e.target.checked,
                  "sales"
                );
              }}
              onFocus={() => {
                executeScroll(allowPromiseOrderRef);
                setCurrentComponent("config_sales_allow_promise_order");
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "config_sales_allow_return",
                  down: "config_sales_round_off",
                  left: "config_sales_allow_return",
                  right: "config_sales_round_off",
                }),
              }}
            />
            <Checkbox
              id="config_sales_round_off"
              name="enableRoundOffOnSales"
              ref={enableRoundOffOnSalesRef}
              label={formLabels?.ENABLE_ROUND_OFF_ON_SALES?.displayName}
              checked={ENABLE_ROUND_OFF_ON_SALES}
              onFocus={() => {
                executeScroll(enableRoundOffOnSalesRef);
                setCurrentComponent("config_sales_round_off");
              }}
              onChange={(e) => {
                // setRoundOffOnSales(e.target.checked);
                props.handleFormChange(
                  "ENABLE_ROUND_OFF_ON_SALES",
                  e.target.checked,
                  "sales"
                );
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "config_sales_allow_promise_order",
                  down: "config_sales_focus_on_patient",
                  left: "config_sales_allow_promise_order",
                  right: "config_sales_focus_on_patient",
                }),
              }}
            />
            <Checkbox
              id="config_sales_focus_on_patient"
              name="startSalesWithPatient"
              ref={startSalesWithPatientRef}
              label={formLabels?.START_SALES_WITH_PATIENT?.displayName}
              checked={START_SALES_WITH_PATIENT}
              onFocus={() => {
                executeScroll(startSalesWithPatientRef);
                setCurrentComponent("config_sales_focus_on_patient");
              }}
              onChange={(e) => {
                // setStartSalesWithPatient(e.target.checked);
                props.handleFormChange(
                  "START_SALES_WITH_PATIENT",
                  e.target.checked,
                  "sales"
                );
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "config_sales_round_off",
                  down: "config_sales_enable_re_order",
                  left: "config_sales_round_off",
                  right: "config_sales_enable_re_order",
                }),
              }}
            />
            {/* <br /> */}
            {/* <Checkbox
              id="sales_edit_patient_avoid_sms"
              name="disableOrderSMS"
              // ref={editPatientAvoidSmsRef}
              label={formLabels?.?.displayName}
              checked={enabelB2BSales}
              //  onFocus={() => setCurrentComponent("sales_edit_patient_avoid_sms")}
              onChange={(e) => {
                setB2BSales(e.target.checked);
                props.handleFormChange(
                  "ENABLE_B2B_SALES",
                  e.target.checked,
                  "sales"
                );
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "sales_edit_patient_address",
                  down: "",
                  left: "sales_edit_patient_credit_limit",
                  right: "sales_edit_patient_tb_details",
                }),
              }}
            /> */}
            {/* <Checkbox
              id="sales_edit_patient_avoid_sms"
              name="disableOrderSMS"
              // ref={editPatientAvoidSmsRef}
              label={formLabels?.?.displayName}
              checked={enableCashCounter}
              //  onFocus={() => setCurrentComponent("sales_edit_patient_avoid_sms")}
              onChange={(e) => {
                setCashCounter(e.target.checked);
                props.handleFormChange(
                  "ENABLE_CASH_COUNTER",
                  e.target.checked,
                  "sales"
                );
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "sales_edit_patient_address",
                  down: "",
                  left: "sales_edit_patient_credit_limit",
                  right: "sales_edit_patient_tb_details",
                }),
              }}
            /> */}
            <Checkbox
              id="config_sales_enable_re_order"
              name="enableReOrderInReport"
              ref={enableReOrderInReportRef}
              label={formLabels?.ENABLE_REORDER_IN_REPORT?.displayName}
              checked={ENABLE_REORDER_IN_REPORT}
              onFocus={() => {
                executeScroll(enableReOrderInReportRef);
                setCurrentComponent("config_sales_enable_re_order");
              }}
              onChange={(e) => {
                // setReOrderInReport(e.target.checked);
                props.handleFormChange(
                  "ENABLE_REORDER_IN_REPORT",
                  e.target.checked,
                  "sales"
                );
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "config_sales_focus_on_patient",
                  down: "config_sales_allow_multiple_sales_tab",
                  left: "config_sales_focus_on_patient",
                  right: "config_sales_allow_multiple_sales_tab",
                }),
              }}
            />
            <Checkbox
              id="config_sales_allow_multiple_sales_tab"
              name="allowMultipleSalesTab"
              ref={allowMultipleSalesTabRef}
              label={formLabels?.ALLOW_MULTIPLE_SALES_TAB?.displayName}
              checked={ALLOW_MULTIPLE_SALES_TAB}
              onFocus={() => {
                executeScroll(allowMultipleSalesTabRef);
                setCurrentComponent("config_sales_allow_multiple_sales_tab");
              }}
              onChange={(e) => {
                // setAllowMultiSales(e.target.checked);
                props.handleFormChange(
                  "ALLOW_MULTIPLE_SALES_TAB",
                  e.target.checked,
                  "sales"
                );
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "config_sales_enable_re_order",
                  down: "config_sales_enable_online_orders",
                  left: "config_sales_enable_re_order",
                  right: "config_sales_enable_online_orders",
                }),
              }}
            />
            <Checkbox
              id="config_sales_enable_online_orders"
              name="onlineOrders"
              ref={enableOnlineOrdersRef}
              label={formLabels?.ENABLE_ONLINE_ORDERS?.displayName}
              checked={ENABLE_ONLINE_ORDERS}
              onFocus={() => {
                executeScroll(enableOnlineOrdersRef);
                setCurrentComponent("config_sales_enable_online_orders");
              }}
              onChange={(e) => {
                // setAllowMultiSales(e.target.checked);
                props.handleFormChange(
                  "ENABLE_ONLINE_ORDERS",
                  e.target.checked,
                  "sales"
                );
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "config_sales_allow_multiple_sales_tab",
                  down: "config_sales_enable_home_delivery",
                  left: "config_sales_allow_multiple_sales_tab",
                  right: "config_sales_enable_home_delivery",
                }),
              }}
            />
            <Checkbox
              id="config_sales_enable_home_delivery"
              name="homeDelivery"
              ref={enableHomeDeliveryRef}
              label={formLabels?.ENABLE_HOME_DELIVERY?.displayName}
              checked={ENABLE_HOME_DELIVERY}
              onFocus={() => {
                executeScroll(enableHomeDeliveryRef);
                setCurrentComponent("config_sales_enable_home_delivery");
              }}
              onChange={(e) => {
                // setAllowMultiSales(e.target.checked);
                props.handleFormChange(
                  "ENABLE_HOME_DELIVERY",
                  e.target.checked,
                  "sales"
                );
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "config_sales_enable_online_orders",
                  down: "config_sales_max_sales_quantity",
                  left: "config_sales_enable_online_orders",
                  right: "config_sales_max_sales_quantity",
                }),
              }}
            />
            <Checkbox
              id="config_sales_enable_whatsapp_send"
              name="enableWhatsappSend"
              ref={enableWhatsappSendRef}
              label={formLabels?.ENABLE_WHATSAPP_SEND?.displayName}
              checked={ENABLE_WHATSAPP_SEND}
              onFocus={() => {
                executeScroll(allowBackdatedSalesRef);
                setCurrentComponent("config_sales_enable_whatsapp_send");
              }}
              onChange={(e) => {
                // setReturnInSales(e.target.checked);
                props.handleFormChange(
                  "ENABLE_WHATSAPP_SEND",
                  e.target.checked,
                  "sales"
                );
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "config_sales_enable_home_delivery",
                  down: "config_sales_max_sales_quantity",
                  left: "config_sales_enable_home_delivery",
                  right: "config_sales_max_sales_quantity",
                }),
              }}
            />
            {/* <br /> */}
            {/* <div className={classes["salesconfig-textbox-wrapper"]}>
              <NumberInput
                id="config_sales_sales_return_period"
                name="distributorName"
                // ref={saleLookBackRef}
                value={salesLookback}
                label={formLabels?.?.displayName}
                // onFocus={() => setCurrentComponent("purchase_edit_distributor_name")}
                onValueChange={(values, e) => {
                  setSalesLookback(values.floatValue);
                  props.handleFormChange(
                    "SALES_LOOK_BACK",
                    values.floatValue,
                    "SALES"
                  );
                }}
                allowNegative={false}
                decimalScale={0}
                // onChange={(e) => {
                //   setSalesLookback(e.target.value);
                //   props.handleFormChange(
                //     "SALES_LOOK_BACK",
                //     e.target.value,
                //     "SALES"
                //   );
                //   handleTextFormChange(e, "SALES_LOOK_BACK");
                // }}
                //onBlur={() => validateForm("distributorName", formState, errorState)}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "",
                    down: "purchase_edit_distributor_address",
                    left: "",
                    right: "purchase_edit_distributor_short_name",
                  }),
                }}
                //   error={checkErrorStateExists(
                //     "purchase_edit_distributor_name",
                //     errorState
                //   )}
              />
            </div> */}
            <div className={classes["salesconfig-textbox-wrapper"]}>
              {/* <TextInput
                id="config_sales_max_sales_quantity"
                name="distributorName"
                // ref={maxSalesQuantity}
                label={formLabels?.?.displayName}
                value={maxSalesQty}
                // onFocus={() => setCurrentComponent("purchase_edit_distributor_name")}
                onChange={(e) => {
                  setMaxSalesQty(e.target.value);
                  props.handleFormChange(
                    "MAX_SALES_QUANTITY",
                    e.target.value,
                    "SALES"
                  );
                  //   handleTextFormChange(e, "MAX_SALES_QUANTITY");
                }}
                //onBlur={() => validateForm("distributorName", formState, errorState)}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "",
                    down: "purchase_edit_distributor_address",
                    left: "",
                    right: "purchase_edit_distributor_short_name",
                  }),
                }}
                //   error={checkErrorStateExists(
                //     "purchase_edit_distributor_name",
                //     errorState
                //   )}
              /> */}
              <NumberInput
                id="config_sales_max_sales_quantity"
                name="maxSalesQty"
                ref={maxSalesQuantityRef}
                label={formLabels?.MAX_SALES_QUANTITY?.displayName}
                value={maxSalesQty}
                onFocus={() => {
                  executeScroll(maxSalesQuantityRef);
                  setCurrentComponent("config_sales_max_sales_quantity");
                }}
                onValueChange={(values, e) => {
                  setMaxSalesQty(values.floatValue);
                  props.handleFormChange(
                    "MAX_SALES_QUANTITY",
                    values.floatValue,
                    "SALES"
                  );
                }}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "config_sales_enable_whatsapp_send",
                    down: "config_sales_show_margin",
                    left: "config_sales_enable_whatsapp_send",
                    right: "config_sales_show_margin",
                  }),
                }}
                isAllowed={(values) => {
                  const { formattedValue } = values;
                  return formattedValue >= 1;
                }}
              />
            </div>
            <div className={classes["salesconfig-textbox-wrapper"]}>
              {/* <TextInput
                id="purchase_edit_distributor_name"
                name="distributorName"
                //ref={editDistributorNameRef}
                label={formLabels?.?.displayName}
                // onFocus={() => setCurrentComponent("purchase_edit_distributor_name")}
                //   onChange={(e) => {
                //     handleFormChange("distributorName", e.target.value);
                //   }}
                //onBlur={() => validateForm("distributorName", formState, errorState)}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "",
                    down: "purchase_edit_distributor_address",
                    left: "",
                    right: "purchase_edit_distributor_short_name",
                  }),
                }}
                //   error={checkErrorStateExists(
                //     "purchase_edit_distributor_name",
                //     errorState
                //   )}
              /> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SalesConfigPanel;
